import { useEffect } from 'react';

const useTemporaryStyle = (
  getElement: () => HTMLElement,
  style: Partial<CSSStyleDeclaration>,
  dependencies: Array<unknown>,
) => {
  useEffect(() => {
    if (style) {
      const originStyle = { ...getElement().style };
      Object.assign(getElement().style, style);

      return () => {
        Object.keys(style).forEach((key: any) => {
          if (getElement().style[key] === style[key]) {
            // eslint-disable-next-line no-param-reassign
            getElement().style[key] = originStyle[key] ?? '';
          }
        });
      };
    }
  }, dependencies);
};

export default useTemporaryStyle;
